import React from "react"
import { Gallery, Box } from "@singita/components"
import MediaWrapper from "./MediaWrapper"
import { showByTag } from "gatsby-singita-theme/src/common/utils"

const LodgeMainGallery = ({ lodge }) => {
  return (
    !!lodge.highlights && (
      <Box data-testid="lodge-highlights-gallery" mb={[6, 16]}>
        <Gallery
          headline={lodge.meta.highlightsTitle}
          variant="triptic"
          hasPagination
          items={lodge.highlights.map(({ caption }) => ({
            desc: caption,
          }))}
          color={lodge.color}
          headingStyles={{
            headline: {
              px: "30px",
            },
          }}
        >
          {showByTag(lodge.highlights, "Singita").map((item, idx) => (
            <MediaWrapper
              key={`highlight-item-${idx}`}
              {...item}
              style={{
                width: "100%",
                height: "100%",
                userSelect: "none",
              }}
              imgStyle={{
                objectFit: "cover",
              }}
            />
          ))}
        </Gallery>
      </Box>
    )
  )
}

export default LodgeMainGallery
